var _defs, _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScores(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.38 130.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.19,
    cy: 65.19,
    r: 65.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.14,203.53c-2.37.51-4.64.8-6.79,1.48a26.73,26.73,0,0,0-11.92,43.24c1.8,2,1.8,2-.13,4-3.74,3.74-7.53,7.44-11.21,11.24-1.24,1.28-2.07,1.28-3.25,0-12.56-14-16.52-30.14-10.6-47.93s18.65-28.28,37-32c2.21-.45,4.49-.55,6.92-.84Z",
    transform: "translate(-196.59 -162.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.37,212.64l15-15.37a10.77,10.77,0,0,0,1,1.82,47.89,47.89,0,0,1,11.79,30c.08,1.74-.36,2.57-2.31,2.54-5.55-.1-11.11-.06-16.66,0-1.27,0-2-.31-2.07-1.76A26.46,26.46,0,0,0,282.37,212.64Z",
    transform: "translate(-196.59 -162.04)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.65,203.66V182.8a47.11,47.11,0,0,1,31.53,12.95l-14.64,15L277,207.94c1.08-3,2.16-5.91,3.22-8.86,1-2.7.31-4.6-1.9-5.53s-3.93-.09-5.19,2.37-2.43,4.78-3.56,7.2c-.47,1-1,1.44-2.16,1.12A33.14,33.14,0,0,0,263.65,203.66Z",
    transform: "translate(-196.59 -162.04)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.48,236.6a6.11,6.11,0,0,1-6-4.66,6.36,6.36,0,0,1,3.38-7.06,6,6,0,0,0,2.45-2.3c4.19-8.23,8.26-16.51,12.37-24.77.24-.48.37-1.12.76-1.39.58-.41,1.62-.95,2-.72a2.38,2.38,0,0,1,.85,2.05c-.91,2.93-2,5.8-3.1,8.69-2.33,6.33-4.71,12.66-7,19a4.62,4.62,0,0,0,0,2.8A6.17,6.17,0,0,1,262.48,236.6Z",
    transform: "translate(-196.59 -162.04)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScores);
export default __webpack_public_path__ + "static/media/scores.67185d66d0e57a5ba2a52fdfe4f8152f.svg";
export { ForwardRef as ReactComponent };